import React from "react";
import styled from "styled-components";
import { getThemeColor, getFontFamily, r } from "../../utils";

import "normalize.css";

/* Font sizes: 
    http://type-scale.com/?size=16&scale=1.414&text=A%20Visual%20Type%20Scale&webfont=Mada&font-family=%27Mada%27,%20sans-serif;&font-weight=bold&font-family-headers=&font-weight-headers=inherit&background-color=white&font-color=#333
  */

export const Header = styled.div`
  display: flex;
  align-items: center;
  font-weight: normal;
  justify-content: ${({ align = "left" }) => {
    return {
      left: "flex-start",
      center: "center",
      right: "flex-end"
    }[align];
  }};
  text-align: ${({ align = "left" }) => align};
  ${getFontFamily};
  color: ${getThemeColor};
  font-weight: ${({ weight = "normal" }) => weight};
`;

export const H1 = Header.extend`
  font-size: 2.3rem;
  line-height: 1.20;
  ${r("padding-bottom", "0.875rem", "1.75rem")};
`;

export const H2 = Header.extend`
  font-size: 2.125rem;
  line-height: 1.20;
  padding-bottom: .625rem;
  ${r("padding-bottom", ".625rem", "1.3rem")};
`;

export const H3 = Header.extend`
  font-size: 1.875rem;
  line-height: 1.3;
  ${r("padding-bottom", ".625rem", "1.3rem")};
`;

export const H4 = Header.extend`
  font-size: 1.414rem;
  line-height: 1.2;
  padding-bottom: .5rem;
`;

export const H5 = Header.extend`
  font-size: 1.2rem;
  line-height: 1.4;
`;



// WEBPACK FOOTER //
// ./src/components/typography/Headers.js